import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
  title: {
    marginBottom: theme.spacing.space12,
  },
  section: {
    marginTop: theme.spacing.space32,
  },
}));
